import { createNextTableContext } from '@core/table';

export const TranslationsTableContext = createNextTableContext();
